// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var EscapeStringRegexp = require("escape-string-regexp");
var URLUtils$SmartcutsMacros = require("../../bs-utils/src/URLUtils.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var Exceptions$SmartcutsMacros = require("./Exceptions.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");

function existential_encode(encoder_a, v) {
  if (typeof v === "number") {
    return ["ShouldNotExist"];
  } else if (v.TAG === /* MightExist */0) {
    return [
            "MightExist",
            Curry._1(encoder_a, v._0)
          ];
  } else {
    return [
            "MustExist",
            Curry._1(encoder_a, v._0)
          ];
  }
}

function existential_decode(decoder_a, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "MightExist" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(decoder_a, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* MightExist */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "MustExist" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(decoder_a, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* MustExist */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ShouldNotExist" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ShouldNotExist */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var regExString_encode = Decco.stringToJson;

var regExString_decode = Decco.stringFromJson;

function t_encode(v) {
  if (v.TAG === /* FixedString */0) {
    return [
            "FixedString",
            Decco.stringToJson(v._0)
          ];
  } else {
    return [
            "RegEx",
            Decco.stringToJson(v._0)
          ];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "FixedString" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FixedString */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "RegEx" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RegEx */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(v) {
  if (v.TAG === /* FixedString */0) {
    return v._0;
  } else {
    return "/" + (v._0 + "/");
  }
}

function toJsReSegment(v) {
  if (v.TAG === /* FixedString */0) {
    return EscapeStringRegexp(v._0);
  } else {
    return v._0;
  }
}

function fixed(s) {
  return {
          TAG: /* FixedString */0,
          _0: s
        };
}

function variable(regExString, param) {
  if (regExString !== undefined) {
    return {
            TAG: /* RegEx */1,
            _0: regExString
          };
  } else {
    return {
            TAG: /* RegEx */1,
            _0: ".+"
          };
  }
}

function doesMatchString(s, pattern) {
  if (pattern.TAG === /* FixedString */0) {
    return s === pattern._0;
  } else {
    return new RegExp(pattern._0).test(s);
  }
}

var StringPattern = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  toJsReSegment: toJsReSegment,
  fixed: fixed,
  variable: variable,
  doesMatchString: doesMatchString
};

function t_encode$1(v) {
  return Decco.arrayToJson(t_encode, v);
}

function t_decode$1(v) {
  return Decco.arrayFromJson(t_decode, v);
}

function toJsReSegments(fixedStringsOrRegExes) {
  return $$Array.map(toJsReSegment, fixedStringsOrRegExes);
}

function fromStringWithSep(sep, isSepLeading, s) {
  var parts = StringUtils$SmartcutsMacros.split(sep, s);
  return Belt_Array.map((
                isSepLeading ? (function (arr) {
                      return Belt_Array.keep(arr, (function (x) {
                                    return x !== "";
                                  }));
                    }) : (function (arr) {
                      return arr;
                    })
              )($$Array.of_list(parts)), (function (param) {
                return {
                        TAG: /* RegEx */1,
                        _0: ".+"
                      };
              }));
}

var StringArrayPattern = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  toJsReSegments: toJsReSegments,
  fromStringWithSep: fromStringWithSep
};

function t_encode$2(v) {
  if (v.TAG === /* FixedString */0) {
    return [
            "FixedString",
            Decco.stringToJson(v._0)
          ];
  } else {
    return [
            "RegExWithOriginal",
            Decco.stringToJson(v._0),
            Decco.stringToJson(v._1)
          ];
  }
}

function t_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "FixedString" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FixedString */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "RegExWithOriginal" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* RegExWithOriginal */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$1(v) {
  if (v.TAG === /* FixedString */0) {
    return v._0;
  } else {
    return "(/" + (v._0 + ("/, " + (v._1 + ")")));
  }
}

function toJsReSegment$1(v) {
  if (v.TAG === /* FixedString */0) {
    return EscapeStringRegexp(v._0);
  } else {
    return v._0;
  }
}

function fixed$1(s) {
  return {
          TAG: /* FixedString */0,
          _0: s
        };
}

function variable$1(regEx, originalValue) {
  if (typeof regEx !== "number") {
    return {
            TAG: /* RegExWithOriginal */1,
            _0: regEx._0,
            _1: originalValue
          };
  }
  if (regEx !== 0) {
    return {
            TAG: /* RegExWithOriginal */1,
            _0: ".+",
            _1: originalValue
          };
  }
  var regExStr = "^" + (EscapeStringRegexp(originalValue) + "$");
  return {
          TAG: /* RegExWithOriginal */1,
          _0: regExStr,
          _1: originalValue
        };
}

function doesMatchString$1(s, pattern) {
  if (pattern.TAG === /* FixedString */0) {
    return s === pattern._0;
  } else {
    return new RegExp(pattern._0).test(s);
  }
}

function removePrivateInfo(pattern) {
  if (pattern.TAG === /* FixedString */0) {
    return {
            TAG: /* FixedString */0,
            _0: pattern._0
          };
  }
  var regExString = pattern._0;
  return {
          TAG: /* RegExWithOriginal */1,
          _0: regExString,
          _1: regExString
        };
}

var StringPatternWithOriginalValue = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$1,
  toJsReSegment: toJsReSegment$1,
  fixed: fixed$1,
  variable: variable$1,
  doesMatchString: doesMatchString$1,
  removePrivateInfo: removePrivateInfo
};

function t_encode$3(v) {
  return Decco.arrayToJson((function (param) {
                return existential_encode(t_encode$2, param);
              }), v);
}

function t_decode$3(v) {
  return Decco.arrayFromJson((function (param) {
                return existential_decode(t_decode$2, param);
              }), v);
}

function fromStringWithSep$1(sep, isSepLeading, s) {
  var parts = StringUtils$SmartcutsMacros.split(sep, s);
  return Belt_Array.map((
                isSepLeading ? (function (arr) {
                      return Belt_Array.keep(arr, (function (x) {
                                    return x !== "";
                                  }));
                    }) : (function (arr) {
                      return arr;
                    })
              )($$Array.of_list(parts)), (function (originalValue) {
                return {
                        TAG: /* MightExist */0,
                        _0: variable$1(/* Loose */1, originalValue)
                      };
              }));
}

var ExistentialStringArrayPatternWithOriginalValues = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  fromStringWithSep: fromStringWithSep$1
};

function t_encode$4(v) {
  return Decco.arrayToJson(t_encode$2, v);
}

function t_decode$4(v) {
  return Decco.arrayFromJson(t_decode$2, v);
}

function fromStringWithSep$2(sep, isSepLeading, s) {
  var parts = StringUtils$SmartcutsMacros.split(sep, s);
  return Belt_Array.map((
                isSepLeading ? (function (arr) {
                      return Belt_Array.keep(arr, (function (x) {
                                    return x !== "";
                                  }));
                    }) : (function (arr) {
                      return arr;
                    })
              )($$Array.of_list(parts)), (function (originalValue) {
                return variable$1(/* Loose */1, originalValue);
              }));
}

var StringArrayPatternWithOriginalValues = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  fromStringWithSep: fromStringWithSep$2
};

function t_encode$5(v) {
  return Decco.arrayToJson((function (param) {
                return existential_encode(t_encode$2, param);
              }), v);
}

function t_decode$5(v) {
  return Decco.arrayFromJson((function (param) {
                return existential_decode(t_decode$2, param);
              }), v);
}

function doesMatchHostname(hostname, pattern) {
  var patternAsList = $$Array.to_list(pattern);
  var hostnamePartsReversed = List.rev($$String.split_on_char(/* '.' */46, hostname));
  if (!hostnamePartsReversed) {
    if (patternAsList) {
      return false;
    } else {
      return true;
    }
  }
  var match = hostnamePartsReversed.tl;
  var singleTermDomain = hostnamePartsReversed.hd;
  if (match) {
    if (!patternAsList) {
      return false;
    }
    var tldPattern = patternAsList.hd;
    if (typeof tldPattern === "number") {
      return false;
    }
    if (tldPattern.TAG === /* MightExist */0) {
      return false;
    }
    var match$1 = patternAsList.tl;
    if (!match$1) {
      return false;
    }
    var sldPattern = match$1.hd;
    if (typeof sldPattern === "number") {
      return false;
    }
    if (sldPattern.TAG === /* MightExist */0) {
      return false;
    }
    var subdomainsArray = $$Array.of_list(match.tl);
    if (doesMatchString$1(singleTermDomain, tldPattern._0) && doesMatchString$1(match.hd, sldPattern._0)) {
      return ArrayUtils$SmartcutsMacros.everyWithIndex($$Array.of_list(match$1.tl), (function (i, existentialSubdomainPattern) {
                    var match = Belt_Array.get(subdomainsArray, i);
                    if (typeof existentialSubdomainPattern === "number") {
                      return match === undefined;
                    } else if (existentialSubdomainPattern.TAG === /* MightExist */0) {
                      if (match !== undefined) {
                        return doesMatchString$1(match, existentialSubdomainPattern._0);
                      } else {
                        return true;
                      }
                    } else if (match !== undefined) {
                      return doesMatchString$1(match, existentialSubdomainPattern._0);
                    } else {
                      return false;
                    }
                  }));
    } else {
      return false;
    }
  } else {
    if (!patternAsList) {
      return false;
    }
    var stringPattern = patternAsList.hd;
    if (typeof stringPattern === "number" || stringPattern.TAG === /* MightExist */0 || patternAsList.tl) {
      return false;
    } else {
      return doesMatchString$1(singleTermDomain, stringPattern._0);
    }
  }
}

var HostnamePattern = {
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  doesMatchHostname: doesMatchHostname
};

function t_encode$6(v) {
  return Decco.optionToJson(t_encode$2, v);
}

function t_decode$6(v) {
  return Decco.optionFromJson(t_decode$2, v);
}

function doesMatchPort(port, pattern) {
  if (pattern !== undefined) {
    return doesMatchString$1(port, pattern);
  } else {
    return port === "";
  }
}

var PortPattern = {
  t_encode: t_encode$6,
  t_decode: t_decode$6,
  doesMatchPort: doesMatchPort
};

function t_encode$7(v) {
  return Decco.arrayToJson(t_encode$2, v);
}

function t_decode$7(v) {
  return Decco.arrayFromJson(t_decode$2, v);
}

function doesMatchPathname(pathname, pattern) {
  var pathnamePartsArray = Belt_Array.keep($$Array.of_list($$String.split_on_char(/* '/' */47, pathname)), (function (x) {
          return x !== "";
        }));
  if (pathnamePartsArray.length === pattern.length) {
    return Belt_Array.every(Belt_Array.zip(pathnamePartsArray, pattern), (function (param) {
                  return doesMatchString$1(param[0], param[1]);
                }));
  } else {
    return false;
  }
}

var PathnamePattern = {
  t_encode: t_encode$7,
  t_decode: t_decode$7,
  doesMatchPathname: doesMatchPathname
};

function t_encode$8(v) {
  if (typeof v === "number") {
    return ["NoVal"];
  } else if (v.TAG === /* SingleVal */0) {
    return [
            "SingleVal",
            t_encode$2(v._0)
          ];
  } else {
    return [
            "MultipleVals",
            Decco.arrayToJson(t_encode$2, v._0)
          ];
  }
}

function t_decode$8(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "MultipleVals" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.arrayFromJson(t_decode$2, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* MultipleVals */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NoVal" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NoVal */0
                  };
          }
      case "SingleVal" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode$2(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SingleVal */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function removePrivateInfo$1(v) {
  if (typeof v === "number") {
    return /* NoVal */0;
  } else if (v.TAG === /* SingleVal */0) {
    return {
            TAG: /* SingleVal */0,
            _0: removePrivateInfo(v._0)
          };
  } else {
    return {
            TAG: /* MultipleVals */1,
            _0: $$Array.map(removePrivateInfo, v._0)
          };
  }
}

var QueryParamValue = {
  t_encode: t_encode$8,
  t_decode: t_decode$8,
  removePrivateInfo: removePrivateInfo$1
};

var key_encode = Decco.stringToJson;

var key_decode = Decco.stringFromJson;

function t_encode$9(v) {
  return existential_encode((function (param) {
                return [
                        Decco.stringToJson(param[0]),
                        t_encode$8(param[1])
                      ];
              }), v);
}

function t_decode$9(v) {
  return existential_decode((function (json) {
                var match = Js_json.classify(json);
                if (typeof match === "number") {
                  return Decco.error(undefined, "Not a tuple", json);
                }
                if (match.TAG !== /* JSONArray */3) {
                  return Decco.error(undefined, "Not a tuple", json);
                }
                var match$1 = match._0;
                if (match$1.length !== 2) {
                  return Decco.error(undefined, "Incorrect cardinality", json);
                }
                var v0 = match$1[0];
                var v1 = match$1[1];
                var match$2 = Decco.stringFromJson(v0);
                var match$3 = t_decode$8(v1);
                if (match$2.TAG === /* Ok */0) {
                  if (match$3.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: [
                              match$2._0,
                              match$3._0
                            ]
                          };
                  }
                  var e = match$3._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                          }
                        };
                }
                var e$1 = match$2._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: "[0]" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }), v);
}

var QueryParamPattern = {
  key_encode: key_encode,
  key_decode: key_decode,
  t_encode: t_encode$9,
  t_decode: t_decode$9
};

function t_encode$10(v) {
  return Decco.arrayToJson(t_encode$9, v);
}

function t_decode$10(v) {
  return Decco.arrayFromJson(t_decode$9, v);
}

function fromSearch(search) {
  if (search.length === 0) {
    return [];
  } else {
    return Belt_Array.map(Belt_MapString.toArray(Belt_Array.reduce($$Array.of_list($$String.split_on_char(/* '&' */38, $$String.sub(search, 1, search.length - 1 | 0))), undefined, (function (queryParamByKey, queryParamAssignmentString) {
                          var index = queryParamAssignmentString.indexOf("=");
                          if (index === -1) {
                            return Belt_MapString.update(queryParamByKey, decodeURIComponent(queryParamAssignmentString), (function (maybeVal) {
                                          if (maybeVal !== undefined && typeof maybeVal !== "number") {
                                            return maybeVal;
                                          } else {
                                            return /* NoVal */0;
                                          }
                                        }));
                          }
                          var key = queryParamAssignmentString.slice(0, index);
                          var value = queryParamAssignmentString.slice(index + 1 | 0);
                          var decodedValue = decodeURIComponent(value);
                          var newVal = variable$1(/* Loose */1, decodedValue);
                          return Belt_MapString.update(queryParamByKey, decodeURIComponent(key), (function (maybeVal) {
                                        if (maybeVal !== undefined && typeof maybeVal !== "number") {
                                          if (maybeVal.TAG === /* SingleVal */0) {
                                            return {
                                                    TAG: /* MultipleVals */1,
                                                    _0: [
                                                      maybeVal._0,
                                                      newVal
                                                    ]
                                                  };
                                          } else {
                                            return {
                                                    TAG: /* MultipleVals */1,
                                                    _0: $$Array.append(maybeVal._0, [newVal])
                                                  };
                                          }
                                        } else {
                                          return {
                                                  TAG: /* SingleVal */0,
                                                  _0: newVal
                                                };
                                        }
                                      }));
                        }))), (function (v) {
                  return {
                          TAG: /* MightExist */0,
                          _0: v
                        };
                }));
  }
}

var QueryParametersPattern = {
  t_encode: t_encode$10,
  t_decode: t_decode$10,
  fromSearch: fromSearch
};

function t_encode$11(v) {
  return existential_encode(t_encode$2, v);
}

function t_decode$11(v) {
  return existential_decode(t_decode$2, v);
}

function doesMatchHash(hash, pattern) {
  if (typeof pattern === "number") {
    return hash === "";
  } else if (pattern.TAG === /* MightExist */0) {
    if (hash === "") {
      return true;
    } else {
      return doesMatchString$1(hash, pattern._0);
    }
  } else if (hash !== "") {
    return doesMatchString$1(hash, pattern._0);
  } else {
    return false;
  }
}

var HashPattern = {
  t_encode: t_encode$11,
  t_decode: t_decode$11,
  doesMatchHash: doesMatchHash
};

function searchParamPattern_encode(v) {
  if (v.TAG === /* SingleVal */0) {
    return [
            "SingleVal",
            t_encode(v._0)
          ];
  } else {
    return [
            "ArrayOfVals",
            t_encode(v._0)
          ];
  }
}

function searchParamPattern_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ArrayOfVals" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ArrayOfVals */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "SingleVal" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SingleVal */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function searchParamNameAndPattern_encode(v) {
  return [
          Decco.stringToJson(v[0]),
          searchParamPattern_encode(v[1])
        ];
}

function searchParamNameAndPattern_decode(v) {
  var match = Js_json.classify(v);
  if (typeof match === "number") {
    return Decco.error(undefined, "Not a tuple", v);
  }
  if (match.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a tuple", v);
  }
  var match$1 = match._0;
  if (match$1.length !== 2) {
    return Decco.error(undefined, "Incorrect cardinality", v);
  }
  var v0 = match$1[0];
  var v1 = match$1[1];
  var match$2 = Decco.stringFromJson(v0);
  var match$3 = searchParamPattern_decode(v1);
  if (match$2.TAG === /* Ok */0) {
    if (match$3.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: [
                match$2._0,
                match$3._0
              ]
            };
    }
    var e = match$3._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[1]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = match$2._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: "[0]" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_encode$12(v) {
  return Js_dict.fromArray([
              [
                "protocol",
                Decco.stringToJson(v.protocol)
              ],
              [
                "hostname",
                Decco.arrayToJson((function (param) {
                        return existential_encode(t_encode$2, param);
                      }), v.hostname)
              ],
              [
                "port",
                Decco.optionToJson(t_encode$2, v.port)
              ],
              [
                "pathname",
                Decco.arrayToJson(t_encode$2, v.pathname)
              ],
              [
                "hash",
                existential_encode(t_encode$2, v.hash)
              ],
              [
                "search",
                Decco.arrayToJson(t_encode$9, v.search)
              ]
            ]);
}

function t_decode$12(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var protocol = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "protocol"), null));
  if (protocol.TAG === /* Ok */0) {
    var v$1 = Belt_Option.getWithDefault(Js_dict.get(dict$1, "hostname"), null);
    var hostname = Decco.arrayFromJson((function (param) {
            return existential_decode(t_decode$2, param);
          }), v$1);
    if (hostname.TAG === /* Ok */0) {
      var port = Decco.optionFromJson(t_decode$2, Belt_Option.getWithDefault(Js_dict.get(dict$1, "port"), null));
      if (port.TAG === /* Ok */0) {
        var pathname = Decco.arrayFromJson(t_decode$2, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pathname"), null));
        if (pathname.TAG === /* Ok */0) {
          var hash = existential_decode(t_decode$2, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hash"), null));
          if (hash.TAG === /* Ok */0) {
            var search = Decco.arrayFromJson(t_decode$9, Belt_Option.getWithDefault(Js_dict.get(dict$1, "search"), null));
            if (search.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        protocol: protocol._0,
                        hostname: hostname._0,
                        port: port._0,
                        pathname: pathname._0,
                        hash: hash._0,
                        search: search._0
                      }
                    };
            }
            var e = search._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".search" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = hash._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".hash" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = pathname._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".pathname" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = port._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".port" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = hostname._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".hostname" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = protocol._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".protocol" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function toChromeMatchPattern(param) {
  var protocolToPathname = param.protocol + ("//" + (Belt_Array.reduceWithIndex(Belt_Array.reverse(param.hostname), [
                [],
                false
              ], (function (param, component, i) {
                  var didSeePattern = param[1];
                  var hostPatterns = param[0];
                  if (typeof component === "number") {
                    return [
                            hostPatterns,
                            didSeePattern
                          ];
                  }
                  if (component.TAG !== /* MightExist */0) {
                    var str = component._0;
                    if (str.TAG === /* FixedString */0) {
                      return [
                              $$Array.append(hostPatterns, [str._0]),
                              didSeePattern
                            ];
                    }
                    
                  }
                  if (i !== 0) {
                    if (didSeePattern) {
                      return [
                              hostPatterns,
                              true
                            ];
                    } else {
                      return [
                              ["*"],
                              true
                            ];
                    }
                  } else {
                    return [
                            ["*"],
                            true
                          ];
                  }
                }))[0].join(".") + ("/" + Belt_Array.map(param.pathname, (function (component) {
                  if (component.TAG === /* FixedString */0) {
                    return component._0;
                  } else {
                    return "*";
                  }
                })).join("/"))));
  if (protocolToPathname.endsWith("*")) {
    return protocolToPathname;
  } else if (typeof param.hash === "number") {
    if (param.search.length !== 0) {
      return protocolToPathname + "*";
    } else {
      return protocolToPathname;
    }
  } else {
    return protocolToPathname + "*";
  }
}

function getOriginalUrl(param) {
  var search = param.search;
  var hash = param.hash;
  var pathname = param.pathname;
  var port = param.port;
  var hostname_ = Belt_Array.reverse(ArrayUtils$SmartcutsMacros.filterMap((function (component) {
                if (typeof component === "number") {
                  return ;
                }
                var v = component._0;
                if (v.TAG === /* FixedString */0) {
                  return v._0;
                } else {
                  return v._1;
                }
              }), param.hostname)).join(".");
  var port_ = port !== undefined ? (
      port.TAG === /* FixedString */0 ? ":" + port._0 : ":" + port._1
    ) : "";
  var pathname_ = pathname.length !== 0 ? "/" + $$Array.map((function (component) {
              if (component.TAG === /* FixedString */0) {
                return component._0;
              } else {
                return component._1;
              }
            }), pathname).join("/") : "";
  var hash_;
  if (typeof hash === "number" || hash.TAG === /* MightExist */0) {
    hash_ = "";
  } else {
    var v = hash._0;
    hash_ = v.TAG === /* FixedString */0 ? "#" + v._0 : "#" + v._1;
  }
  var search_ = search.length !== 0 ? Belt_Array.reduce(search, "?", (function (searchString, component) {
            var kv;
            if (typeof component === "number") {
              kv = undefined;
            } else {
              var match = component._0;
              var value = match[1];
              var key = match[0];
              if (typeof value === "number") {
                kv = undefined;
              } else if (value.TAG === /* SingleVal */0) {
                var v = value._0;
                kv = v.TAG === /* FixedString */0 ? [
                    key,
                    v._0
                  ] : [
                    key,
                    v._1
                  ];
              } else {
                kv = Util$SmartcutsMacros.logAndRaiseJsError("TODO: unhandled MultipleVals(_) at UrlPattern.getOriginalUrl()");
              }
            }
            if (kv === undefined) {
              return searchString;
            }
            var v$1 = kv[1];
            var k = kv[0];
            if (searchString === "?") {
              return searchString + (k + ("=" + v$1));
            } else {
              return searchString + ("&" + (k + ("=" + v$1)));
            }
          })) : "";
  return param.protocol + ("//" + (hostname_ + (port_ + (pathname_ + (hash_ + search_)))));
}

function removePrivateInfo$2(urlConstraint) {
  var pathname = $$Array.map(removePrivateInfo, urlConstraint.pathname);
  var v = urlConstraint.hash;
  var hash;
  hash = typeof v === "number" ? /* ShouldNotExist */0 : (
      v.TAG === /* MightExist */0 ? ({
            TAG: /* MightExist */0,
            _0: removePrivateInfo(v._0)
          }) : ({
            TAG: /* MustExist */1,
            _0: removePrivateInfo(v._0)
          })
    );
  var search = Belt_Array.map(urlConstraint.search, (function (component) {
          if (typeof component === "number") {
            return /* ShouldNotExist */0;
          }
          if (component.TAG === /* MightExist */0) {
            var match = component._0;
            return {
                    TAG: /* MightExist */0,
                    _0: [
                      match[0],
                      removePrivateInfo$1(match[1])
                    ]
                  };
          }
          var match$1 = component._0;
          return {
                  TAG: /* MustExist */1,
                  _0: [
                    match$1[0],
                    removePrivateInfo$1(match$1[1])
                  ]
                };
        }));
  return {
          protocol: urlConstraint.protocol,
          hostname: urlConstraint.hostname,
          port: urlConstraint.port,
          pathname: pathname,
          hash: hash,
          search: search
        };
}

function fromUrl(u) {
  var parts = List.rev(StringUtils$SmartcutsMacros.split(".", u.hostname));
  var tmp;
  if (parts) {
    var match = parts.tl;
    var singleTermDomain = parts.hd;
    tmp = match ? $$Array.of_list({
            hd: {
              TAG: /* MustExist */1,
              _0: {
                TAG: /* FixedString */0,
                _0: singleTermDomain
              }
            },
            tl: {
              hd: {
                TAG: /* MustExist */1,
                _0: {
                  TAG: /* FixedString */0,
                  _0: match.hd
                }
              },
              tl: List.map((function (subdomain) {
                      return {
                              TAG: /* MightExist */0,
                              _0: variable$1(/* Loose */1, subdomain)
                            };
                    }), match.tl)
            }
          }) : [{
          TAG: /* MustExist */1,
          _0: {
            TAG: /* FixedString */0,
            _0: singleTermDomain
          }
        }];
  } else {
    tmp = [];
  }
  return {
          protocol: u.protocol,
          hostname: tmp,
          port: OptionUtils$SmartcutsMacros.map(OptionUtils$SmartcutsMacros.optionalString(u.port), (function (port) {
                  return variable$1(/* Loose */1, port);
                })),
          pathname: fromStringWithSep$2("/", true, u.pathname),
          hash: {
            TAG: /* MightExist */0,
            _0: variable$1(/* Loose */1, u.hash)
          },
          search: fromSearch(u.search)
        };
}

function doesMatchUrl(url, pattern) {
  if (url.protocol === pattern.protocol && doesMatchPort(url.port, pattern.port) && doesMatchHostname(url.hostname, pattern.hostname) && doesMatchPathname(url.pathname, pattern.pathname)) {
    return doesMatchHash(url.hash, pattern.hash);
  } else {
    return false;
  }
}

var UrlPattern = {
  searchParamPattern_encode: searchParamPattern_encode,
  searchParamPattern_decode: searchParamPattern_decode,
  searchParamNameAndPattern_encode: searchParamNameAndPattern_encode,
  searchParamNameAndPattern_decode: searchParamNameAndPattern_decode,
  t_encode: t_encode$12,
  t_decode: t_decode$12,
  toChromeMatchPattern: toChromeMatchPattern,
  getOriginalUrl: getOriginalUrl,
  removePrivateInfo: removePrivateInfo$2,
  fromUrl: fromUrl,
  doesMatchUrl: doesMatchUrl
};

function t_encode$13(v) {
  if (v) {
    return [
            "FlexibleMatch",
            t_encode$12(v._0)
          ];
  } else {
    return ["ExactMatch"];
  }
}

function t_decode$13(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ExactMatch" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ExactMatch */0
                  };
          }
      case "FlexibleMatch" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$12(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* FlexibleMatch */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function flexibleMatchFromUrlString(url) {
  var urlRecord = URLUtils$SmartcutsMacros.$$URL.fromString(url);
  if (urlRecord !== undefined) {
    return /* FlexibleMatch */{
            _0: fromUrl(urlRecord)
          };
  }
  throw {
        RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
        _1: url,
        Error: new Error()
      };
}

function groupGen(urls) {
  return Belt_Array.reduce(urls, [], (function (groups, url) {
                if ($$Array.exists((function (param) {
                          return Curry._1(param[1], url);
                        }), groups)) {
                  return groups;
                }
                var segments = fromStringWithSep$2("/", true, url.pathname);
                var pathPattern = Belt_Array.reduceWithIndex(segments, segments, (function (patternWithDynamicPath, stringPattern, index) {
                        var arg;
                        arg = stringPattern.TAG === /* FixedString */0 ? stringPattern : ({
                              TAG: /* FixedString */0,
                              _0: stringPattern._1
                            });
                        var patternWithFixedPath = (function (param) {
                              return ArrayUtils$SmartcutsMacros.replaceAtIndex(param, index, arg);
                            })(patternWithDynamicPath);
                        var match = Belt_Array.keep(urls, (function (url) {
                                return doesMatchPathname(url.pathname, patternWithFixedPath);
                              }));
                        var match$1 = Belt_Array.keep(urls, (function (url) {
                                return doesMatchPathname(url.pathname, patternWithDynamicPath);
                              }));
                        if (match.length > 1 || !(match.length < match$1.length || match.length !== match$1.length)) {
                          return patternWithFixedPath;
                        } else {
                          return patternWithDynamicPath;
                        }
                      }));
                var indexOfRegExps = ArrayUtils$SmartcutsMacros.filterMapi((function (index, stringPattern) {
                        if (stringPattern.TAG === /* FixedString */0) {
                          return ;
                        } else {
                          return index;
                        }
                      }), pathPattern);
                var hostname = url.hostname;
                var key = hostname + ("/" + $$Array.mapi((function (index, stringPattern) {
                            if (stringPattern.TAG === /* FixedString */0) {
                              return stringPattern._0;
                            }
                            var match = indexOfRegExps.length;
                            if (match === 1) {
                              return ":id";
                            }
                            var nth = indexOfRegExps.indexOf(index);
                            return ":id" + String(nth + 1 | 0);
                          }), pathPattern).join("/"));
                var fn = function (url) {
                  if (url.hostname === hostname) {
                    return doesMatchPathname(url.pathname, pathPattern);
                  } else {
                    return false;
                  }
                };
                return $$Array.append(groups, [[
                              key,
                              fn
                            ]]);
              }));
}

exports.existential_encode = existential_encode;
exports.existential_decode = existential_decode;
exports.regExString_encode = regExString_encode;
exports.regExString_decode = regExString_decode;
exports.StringPattern = StringPattern;
exports.StringArrayPattern = StringArrayPattern;
exports.StringPatternWithOriginalValue = StringPatternWithOriginalValue;
exports.ExistentialStringArrayPatternWithOriginalValues = ExistentialStringArrayPatternWithOriginalValues;
exports.StringArrayPatternWithOriginalValues = StringArrayPatternWithOriginalValues;
exports.HostnamePattern = HostnamePattern;
exports.PortPattern = PortPattern;
exports.PathnamePattern = PathnamePattern;
exports.QueryParamValue = QueryParamValue;
exports.QueryParamPattern = QueryParamPattern;
exports.QueryParametersPattern = QueryParametersPattern;
exports.HashPattern = HashPattern;
exports.UrlPattern = UrlPattern;
exports.t_encode = t_encode$13;
exports.t_decode = t_decode$13;
exports.flexibleMatchFromUrlString = flexibleMatchFromUrlString;
exports.groupGen = groupGen;
/* Util-SmartcutsMacros Not a pure module */
